module.exports = __webpack_public_path__ + "static/img/videoLive.995c165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoLive.png
// module id = aCy1
// module chunks = 20